const catalogDesktopQuery = window.matchMedia('(min-width: 900px)');
const initializedFacetPanels = new WeakSet();

const submitCatalogForm = (form) => {
  if (!(form instanceof HTMLFormElement)) return;
  form.setAttribute('aria-busy', 'true');
  form.requestSubmit();
};

const syncFacetPanel = (panel) => {
  if (!(panel instanceof HTMLDetailsElement)) return;

  if (catalogDesktopQuery.matches) {
    panel.open = true;
    return;
  }

  panel.open = panel.dataset.mobileOpen === 'true';
};

const initializeFacetPanels = (scope = document) => {
  scope.querySelectorAll('[data-facets-panel]').forEach((panel) => {
    if (!(panel instanceof HTMLDetailsElement) || initializedFacetPanels.has(panel)) return;

    const hasActiveFilters = Number(panel.dataset.activeCount || 0) > 0;
    panel.dataset.mobileOpen = hasActiveFilters ? 'true' : 'false';

    panel.addEventListener('toggle', () => {
      if (!catalogDesktopQuery.matches) {
        panel.dataset.mobileOpen = panel.open ? 'true' : 'false';
      }
    });

    initializedFacetPanels.add(panel);
    syncFacetPanel(panel);
  });
};

document.addEventListener('change', (event) => {
  const control = event.target;
  if (!(control instanceof HTMLInputElement || control instanceof HTMLSelectElement)) return;

  if (control.matches('[data-auto-submit]') && catalogDesktopQuery.matches) {
    submitCatalogForm(control.form);
  }

  if (control.matches('[data-sort-select]')) {
    const formId = control.getAttribute('form');
    const form = formId ? document.getElementById(formId) : control.form;
    const hiddenSort = form?.querySelector('[data-sort-input]');
    if (hiddenSort) hiddenSort.value = control.value;
    submitCatalogForm(form);
  }
});

document.addEventListener('submit', (event) => {
  const form = event.target;
  if (form instanceof HTMLFormElement && (form.matches('[data-facets-form]') || form.matches('[data-sort-form]'))) {
    form.setAttribute('aria-busy', 'true');
  }
});

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-collection-products-jump]');
  if (!(trigger instanceof HTMLButtonElement)) return;
  const targetId = trigger.dataset.target;
  const target = targetId ? document.getElementById(targetId) : null;
  target?.focus();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeFacetPanels(event.target);
});

catalogDesktopQuery.addEventListener('change', () => {
  document.querySelectorAll('[data-facets-panel]').forEach(syncFacetPanel);
});

window.addEventListener('pageshow', () => {
  document.querySelectorAll('[data-facets-form][aria-busy="true"], [data-sort-form][aria-busy="true"]').forEach((form) => {
    form.removeAttribute('aria-busy');
  });
});

initializeFacetPanels();
